import type {
  TextareaHTMLAttributes,
} from 'react'

export interface TextAreaProps
  extends Omit<
    TextareaHTMLAttributes<HTMLTextAreaElement>,
    'onChange'
  > {
  label?: string
  value?: string
  onChange?: (
    value: string,
  ) => void
  errorMessage?: string
  isInvalid?: boolean
}

export function TextArea({
  label,
  value = '',
  onChange,
  errorMessage,
  isInvalid = false,
  className,
  ...props
}: TextAreaProps) {
  return (
    <div className="w-full">
      {label && (
        <label className="mb-2 block text-sm font-medium">
          {label}
        </label>
      )}

      <textarea
        {...props}
        value={value}
        onChange={event =>
          onChange?.(
            event.target.value,
          )
        }
        aria-invalid={
          isInvalid
        }
        className={[
          'min-h-28 w-full resize-y rounded-md border bg-(--color-surface) px-3 py-2 text-sm',
          'outline-none transition-colors',
          'focus:border-(--color-primary) focus:ring-2 focus:ring-(--color-primary)/20',
          isInvalid
            ? 'border-red-500'
            : 'border-(--color-border)',
          className ?? '',
        ].join(' ')}
      />

      {isInvalid &&
        errorMessage && (
          <p className="mt-1 text-sm text-red-600">
            {errorMessage}
          </p>
        )}
    </div>
  )
}